import { isElectron } from './environment';
import type { User } from 'types/backend';

export interface SessionResponse {
  sessionId: string;
  csrfToken: string;
  user: User;
}

const SESSION_STORAGE_KEY = 'session_id';
const CSRF_TOKEN_STORAGE_KEY = 'header_csrf_token';

export async function storeSessionId(sessionId: string): Promise<void> {
  try {
    if (isElectron) {
      await window.electronAPI.storeSecureValue(SESSION_STORAGE_KEY, sessionId);
    }
  } catch (error) {
    console.error('Failed to store session ID:', error);
  }
}

export async function getSessionId(): Promise<string | null> {
  try {
    if (isElectron) {
      return await window.electronAPI.getSecureValue(SESSION_STORAGE_KEY);
    } else {
      return null;
    }
  } catch (error) {
    console.error('Failed to get session ID:', error);
    return null;
  }
}

export async function clearSessionId(): Promise<void> {
  try {
    if (isElectron) {
      await window.electronAPI.deleteSecureValue(SESSION_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Failed to clear session ID:', error);
  }
}

export async function storeHeaderCsrfToken(csrfToken: string): Promise<void> {
  try {
    if (isElectron) {
      await window.electronAPI.storeSecureValue(CSRF_TOKEN_STORAGE_KEY, csrfToken);
    }
  } catch (error) {
    console.error('Failed to store header CSRF token:', error);
  }
}

export async function getHeaderCsrfToken(): Promise<string | null> {
  try {
    if (isElectron) {
      return await window.electronAPI.getSecureValue(CSRF_TOKEN_STORAGE_KEY);
    } else {
      return null;
    }
  } catch (error) {
    console.error('Failed to get header CSRF token:', error);
    return null;
  }
}

export async function clearHeaderCsrfToken(): Promise<void> {
  try {
    if (isElectron) {
      await window.electronAPI.deleteSecureValue(CSRF_TOKEN_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Failed to clear header CSRF token:', error);
  }
}
